<ng-container *transloco="let t; read 'home.calculator'">
  <div *ngIf="typeCalculationSelected" @inOutAnimation [formGroup]="formGroup">
    <div class="text-blue1 text-2xl my-4  pb-2 text-center border-b border-sun-yellow" *ngIf="!advanced">
      {{ t('consumption-input.title') }}
    </div>

    <!-- Hourly file input -->
    <psc-file-input
      *ngIf="formGroup.controls['consumption_input_type']?.value && formGroup.controls['consumption_input_type'].value === ConsumptionValueInputType.Hourly; else monthly"
      @inOutAnimation
      formControlName="consumption_file"
      [label]="t('import_consumption_file.title')"
      [infoText]="formGroup.controls['country'].value === PriceCountry.HR ? t('import_consumption_file.info.hr') : t('import_consumption_file.info.bih')"
    ></psc-file-input>

    <!-- Exists to add underline class into taiwlind configuration. Without this the class is not loaded. -->
    <div class="underline"></div>

    <!-- Monthly manual inputs -->
    <ng-template #monthly>

      <div @inOutAnimation class="flex items-center gap-3 my-5" *ngIf="advanced">
        <h5 class="text-color-blue1">
          {{t('consumption_unit_type')}} (kWh/{{currency}}):
        </h5>
        <psc-switch
          labelClass="text-color-sun-yellow !text-base !font-bold"
          formControlName="consumption_unit_type"
          [checkedLabel]="currency"
          uncheckedLabel="kWh"></psc-switch>
      </div>

      <psc-input
        @inOutAnimation
        *ngIf="formGroup.controls['consumption_unit_type'].value === true"
        formControlName="consumption_average_bill"
        [label]="t('consumption_average_bill.title')"
        [prefix]="currency"
        type="number"></psc-input>

      <ng-container *ngIf="formGroup.controls['consumption_unit_type'].value === false">
        <psc-select
          @inOutAnimation
          formControlName="consumption_input_type"
          [label]="t('tariff.type_of_values')"
          [infoText]="t('tariff.info')"
          [options]="[
              {label: t('tariff.average'),  value: ConsumptionValueInputType.MonthlyAverage},
              {label: t('tariff.month_by_month'),  value: ConsumptionValueInputType.MonthByMonth},
              ]"
          [isDisabled]="!selectedTariff"
        ></psc-select>

        <ng-container [ngSwitch]="formGroup.controls['consumption_input_type'].value">
          <ng-container formArrayName="consumption">
            <div
              class="py-4"
              *ngSwitchCase="ConsumptionValueInputType.MonthByMonth">
              <psc-button
                @inOutAnimation
                [label]="this.consumption.value?.length > 0 ? t('edit_monthly_dialog'):  t('open_monthly_dialog')"
                (buttonClicked)="showMultipleConsumptionInputDialog = true"
                type="secondary-blue"></psc-button>
            </div>

            <div class="flex gap-3" *ngSwitchCase="ConsumptionValueInputType.MonthlyAverage">
              <psc-input
                @inOutAnimation
                class="flex-1"
                [formControlName]="0"
                [label]="t(consumption.controls.length === 1 ? 'consumption.title' : 'consumption.consumptionNT')"
                prefix="kWh"
                type="number"></psc-input>
              <psc-input
                @inOutAnimation
                *ngIf="manager.tariffHasTwoPrices"
                class="flex-1"
                [formControlName]="1"
                [label]="t('consumptionVT.title')"
                prefix="kWh"
                type="number"></psc-input>
            </div>
          </ng-container>
        </ng-container>

      </ng-container>
      <div
        @inOutAnimation
        *ngIf="formGroup.controls['country'].value === PriceCountry.HR && consumptionOverHigherPriceLimit && selectedTariff?.type === PriceType.HOME"
        class="text-gray-500 mb-2">
        *{{t('consumption_over_higher_price_limit', { limit: higherPriceLimit / 2 })}}
      </div>

    </ng-template>
  </div>

  <psc-dialog
    *ngIf="showMultipleConsumptionInputDialog"
    [title]="t('input_monthly')"
    (closeClicked)="showMultipleConsumptionInputDialog = false">
    <psc-consumption-input
      [consumptionValues]="consumption.value"
      [tariffHasTwoPrices]="manager.tariffHasTwoPrices"
      (cancel)="showMultipleConsumptionInputDialog = false"
      (consumptionValuesSaved)="saveMultipleConsumptions($event)"
    ></psc-consumption-input>
  </psc-dialog>
  <psc-dialog
    *ngIf="invalidConsumptionFile"
    [title]="t('invalid_consumption_file.title')"
    (closeClicked)="invalidConsumptionFile = false">
    <div [innerHTML]="t('invalid_consumption_file.body')">
    </div>
    <div class="flex justify-center mt-4 gap-2">
      <img src="assets/images/example-consumption.png" alt="Consumption example minute"/>
      <img src="assets/images/consumption-example-hourly.png" alt="Consumption example hourly"/>
    </div>
  </psc-dialog>
</ng-container>

